const PARKER_PATHS = {
  me: '/me',
  wallet: '/me/wallet',
  packs: '/me/packs',
  vehicles: '/me/vehicles',
  reservations: '/me/reservations',
};

export const useParker = async () => {
  if (!useUser().getUser.id) return;

  const api = useApiV2();
  const results = await Promise.all(Object.values(PARKER_PATHS).map((path) => api.get(path)));
  const failed = results.find((result) => result.error);
  if (failed) {
    console.error('❌ Error getting parker', failed.error);
    return { error: failed.error };
  }

  const parts = Object.fromEntries(Object.keys(PARKER_PATHS).map((key, i) => [key, results[i].data]));
  useParkerStore().setParker(parkerFromV2(parts));
  return { error: null };
}
